import type {FormStubFragment} from 'nutshell-graphql-types';

export function getStagesetLabel(form: FormStubFragment) {
    if (form.createRules && form.createRules.lead) {
        if (form.createRules.lead.stageset) {
            return form.createRules.lead.stageset.name;
        }

        // If the stageset exists but is null, that means the form is auto distributing leads
        if (form.createRules.lead.stageset === null) {
            return 'Auto distribute';
        }

        return null;
    }

    return null;
}
